export default "https://fenwan.cdn.bcebos.com/gamecenter/static/game/assets/imgs/download-icon1.1cc4ce22.png";